import { ApiClient } from "./client";
import { frontendEnvironment } from "./env";
import { ApiError } from "./errors";

export type DependencyHealth = boolean | "NA";

export interface BackendHealthResponse {
  status: boolean;
  db?: DependencyHealth;
  redis?: DependencyHealth;
  build_commit?: string;
}

function isDependencyHealth(value: unknown): value is DependencyHealth {
  return typeof value === "boolean" || value === "NA";
}

function isBackendHealthResponse(value: unknown): value is BackendHealthResponse {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const candidate = value as Record<string, unknown>;
  return (
    typeof candidate.status === "boolean" &&
    (candidate.db === undefined || isDependencyHealth(candidate.db)) &&
    (candidate.redis === undefined || isDependencyHealth(candidate.redis)) &&
    (candidate.build_commit === undefined || typeof candidate.build_commit === "string")
  );
}

export const apiClient = new ApiClient({
  baseUrl: frontendEnvironment.apiBaseUrl,
  timeoutMs: frontendEnvironment.apiTimeoutMs,
});

export async function getBackendHealth(
  signal?: AbortSignal,
): Promise<BackendHealthResponse> {
  const response = await apiClient.get<unknown>("/_health", { signal });
  if (!isBackendHealthResponse(response)) {
    throw new ApiError({
      kind: "parse",
      message: "Backend health response does not match the expected contract.",
      details: response,
    });
  }
  return response;
}
